import React from "react";

import Fields from "./Fields";

export default function SubFields({ fields, fieldsState, onChange }) {
  return (
    <Fields fields={fields} fieldsState={fieldsState} onChange={onChange} />
  );
}
